{/*import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/PlansPage.css";
import Navbar from "../components/Navbar";

const PlansPage = () => {
  const navigate = useNavigate();

  const handleSubscribe = () => {
    navigate("/recruiter-dashboard");
  };

  return (
    <>
      <Navbar />
      <div className="plans-container">
        <h1>Hiring Made Easy</h1>
        <p className="subtitle">for Small & Medium Businesses</p>

        <div className="plans-grid">
          <div className="plan-card">
            <h4>Basic</h4>
            <h3>Post a job and get relevant applies</h3>
            <ul>
              <li>Attract qualified candidates actively seeking new roles</li>
              <li>Customize job posting as per your needs</li>
            </ul>
            <button onClick={handleSubscribe}>View Plans</button>
          </div>

          <div className="plan-card">
            <h4>Resdex</h4>
            <h3>Search resume database</h3>
            <ul>
              <li>Discover local talent in every city</li>
              <li>Find the right fit by skills & experience</li>
            </ul>
            <button onClick={handleSubscribe}>View Plans</button>
          </div>

          <div className="plan-card">
            <h4>Assisted Hiring</h4>
            <h3>Get a dedicated hiring expert</h3>
            <ul>
              <li>Our experts shortlist top candidates for you</li>
              <li>Screen and share resumes instantly</li>
            </ul>
            <button onClick={handleSubscribe}>View Plans</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PlansPage;

*/}

import React, { useState,useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import "../styles/PlansPage.css";

const PlansPage = () => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [recruiter, setRecruiter] = useState({
      fullName: "Loading...",
      email: "Loading...",
      companyName: "Loading...",
      logo: null,
    });
  
  {/*const [recruiter, setRecruiter] = useState({
    fullName: "John Doe",
    email: "john.doe@company.com",
    companyName: "TechNova Pvt. Ltd.",
  });

  useEffect(() => {
    // Try to fetch recruiter info from different localStorage keys
    const storedRecruiter =
      JSON.parse(localStorage.getItem("recruiterProfile")) ||
      JSON.parse(localStorage.getItem("recruiterDetails")) ||
      null;

    if (storedRecruiter) {
      setRecruiter({
        fullName: storedRecruiter.fullName || storedRecruiter.name || "Recruiter",
        email: storedRecruiter.email || "email@example.com",
        companyName:
          storedRecruiter.companyName ||
          storedRecruiter.company ||
          "Company Name",
      });
    }
  }, []);*/}
   // added on this file intergration 27-11-2025

  useEffect(() => {
  const fetchRecruiter = async () => {
    try {
      const token = localStorage.getItem("access_token");  // update if your token key is different

      const res = await fetch("http://144.91.102.67:8002/api/recruiter/me", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        console.error("Failed to fetch recruiter profile");
        return;
      }

      const data = await res.json();

      setRecruiter({
        fullName: data.full_name || "Recruiter",
        email: data.email || "email@example.com",
        companyName: data.company_name || "Company Name",
        logo: data.logo || null,
      });

      localStorage.setItem("recruiterProfile", JSON.stringify(data));
    } catch (error) {
      console.error("Error loading recruiter:", error);
    }
  };

  fetchRecruiter();
}, []);

  const handleSubscribe = () => {
    // Simulate successful subscription
    alert("✅ Subscription successful! Redirecting to Dashboard...");
    navigate("/recruiter-dashboard");
  };

  // Get recruiter info from localStorage
  //const recruiter = JSON.parse(localStorage.getItem("recruiterProfile")) || {
    //fullName: "John Doe",
    //email: "john.doe@company.com",
    //companyName: "TechNova Pvt. Ltd.",
  //};

  return (
    <div className="plans-container">
      {/* 🔹 Navbar Section */}
      <nav className="plans-navbar">
        <div className="plans-logo"> StrideNext HireConnect</div>

        <div
          className="profile-container"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <FaUserCircle className="profile-icon" size={32} />
          <span className="profile-name">{recruiter.fullName}</span>

          {showDropdown && (
            <div className="profile-dropdown">
              <p className="profile-header">
                <strong>{recruiter.fullName}</strong>
                <br />
                <small>{recruiter.email}</small>
              </p>
              <hr />
              <Link to="/recruiter-profile" className="dropdown-item">
                View Profile
              </Link>
              <Link to="/settings" className="dropdown-item">
                Settings
              </Link>
              <button
                className="dropdown-item logout"
                onClick={() => {
                  localStorage.clear();
                  navigate("/");
                }}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* 🔹 Page Title */}
      <div className="plans-header">
        <h2>Choose the Best Plan for Your Hiring Needs</h2>
        <p>Subscribe to explore advanced recruitment tools and features</p>
      </div>

      {/* 🔹 Plans Section */}
      <div className="plans-list">
        <div className="plan-card">
          <h3>Basic Plan</h3>
          <p>Perfect for startups or small businesses.</p>
          <ul>
            <li>✔️ 5 Job Posts / Month</li>
            <li>✔️ Access to 50 Candidates</li>
            <li>✔️ Email Support</li>
          </ul>
          <button onClick={handleSubscribe} className="subscribe-btn">
            Subscribe ₹499/month
          </button>
        </div>

        <div className="plan-card popular">
          <h3>Professional Plan</h3>
          <p>Best value for growing teams.</p>
          <ul>
            <li>✔️ 15 Job Posts / Month</li>
            <li>✔️ Access to 250 Candidates</li>
            <li>✔️ Featured Employer Badge</li>
          </ul>
          <button onClick={handleSubscribe} className="subscribe-btn">
            Subscribe ₹999/month
          </button>
        </div>

        <div className="plan-card ">
          <h3>Pro Plan</h3>
          <p>Best value for growing teams.</p>
          <ul>
            <li>✔️ 20 Job Posts / Month</li>
            <li>✔️ Access to 500 Candidates</li>
            <li>✔️ Dedicated Support</li>
            <li>✔️ Featured Employer Badge</li>
          </ul>
          <button onClick={handleSubscribe} className="subscribe-btn">
            Subscribe ₹1999/month
          </button>
        </div>


        <div className="plan-card">
          <h3>Enterprise Plan</h3>
          <p>For large organizations with ongoing hiring needs.</p>
          <ul>
            <li>✔️ Unlimited Job Posts</li>
            <li>✔️ Unlimited Candidate Access</li>
            <li>✔️ Account Manager</li>
            <li>✔️ API Access</li>
          </ul>
          <button onClick={handleSubscribe} className="subscribe-btn">
            Subscribe ₹2499/month
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlansPage;

